export default function deleteChecklist (state, checklistId) {
  state.checklistItems = state.checklistItems.filter(item => item.checklistId !== checklistId)
  state.checklists = state.checklists.filter(item => item.id !== checklistId)
}
